<div
  class="p-d-flex"
  style="
    white-space: normal;
    word-wrap: break-word;
    overflow: auto;
    text-align: left;
    line-height: 1.2;
    height: auto;
    object-fit: contain;
    word-break: break-word;
    margin: 20px 2.5px;
    padding: 10px 2.5px;
  "
>
  <span [innerHTML]="safeHtml" (mousedown)="handleRichTextClick($event)"></span>
</div> 